/*
 * Scroll reveal — single IntersectionObserver for all [data-reveal] nodes.
 * Adds .is-revealed when the element enters the viewport, then unobserves.
 * Honors prefers-reduced-motion by revealing instantly, and re-runs on
 * Theme Editor section loads and on AJAX content swaps (oilogic:collection:updated),
 * which insert fresh unobserved [data-reveal] nodes.
 */
(function () {
  const revealAll = (root) => {
    root.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-revealed'));
  };

  if (
    typeof IntersectionObserver === 'undefined' ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    revealAll(document);
    document.addEventListener('shopify:section:load', (e) => revealAll(e.target));
    document.addEventListener('oilogic:collection:updated', () => revealAll(document));
    return;
  }

  const onIntersect = (entries, obs) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-revealed');
      obs.unobserve(entry.target);
    }
  };

  const rootMargin = '0px 0px -10% 0px';
  const observer = new IntersectionObserver(onIntersect, { threshold: 0.15, rootMargin });
  // Elements taller than ~half the viewport (e.g. the PLP product grid) may
  // never reach a 15% intersection ratio, so any visible part reveals them.
  const tallObserver = new IntersectionObserver(onIntersect, { threshold: 0, rootMargin });

  function observeAll(root = document) {
    root.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach((el) => {
      const tall = el.offsetHeight > window.innerHeight * 0.5;
      (tall ? tallObserver : observer).observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observeAll(), { once: true });
  } else {
    observeAll();
  }

  document.addEventListener('shopify:section:load', (e) => observeAll(e.target));
  document.addEventListener('oilogic:collection:updated', () => observeAll());
})();
